import { render, staticRenderFns } from "./secPasswordModal.vue?vue&type=template&id=212164c1&scoped=true"
import script from "./secPasswordModal.vue?vue&type=script&lang=js"
export * from "./secPasswordModal.vue?vue&type=script&lang=js"
import style0 from "./secPasswordModal.vue?vue&type=style&index=0&id=212164c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212164c1",
  null
  
)

export default component.exports